import { Anchor, AnchorModel, Box, Link, VStack } from '@bpba/ui-components';
import { FOOTER_DATA } from '../../constants/data';
import styled from 'styled-components';

export const Copyright = () => {
  const tycs = new AnchorModel(
    0,
    FOOTER_DATA.tycs.titulo,
    new Link(FOOTER_DATA.tycs.enlace.ruta, FOOTER_DATA.tycs.enlace.isExterno, FOOTER_DATA.tycs.enlace.abreSolapa)
  );

  return (
    <VStack>
      <CenteredLink data={tycs} margin={'24px 0px 0px 0px'} textAlign={'center'} variant={'transparent'}>
        {tycs.titulo}
      </CenteredLink>
      <CenteredText tabIndex={0}>{FOOTER_DATA.copyright}</CenteredText>
    </VStack>
  );
};

const CenteredText = styled(Box)({ marginTop: '24px', textAlign: 'center', justifyContent: 'center', cursor: 'default' });

const CenteredLink = styled(Anchor)({ textAlign: 'center' });
